module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_8011.aeca0100.png";